import React from 'react';
import { User, Avatar, Tooltip, Chip } from '@heroui/react';
import { useUser } from '../../../contexts/UserContext.jsx';
import { Crown, Star } from 'lucide-react';
import Balatro from '../../ui/Balatro.jsx';
import { cn } from '../../../utils/cn.js';

const SidebarFooter = ({ collapsed }) => {
    const { user } = useUser();

    const userAvatar = user?.avatar_url || `https://i.pravatar.cc/150?u=${user?.email || 'admin@v2board.com'}`;
    const userName = user?.nickname || 'Dragon Admin';
    const userDesc = user?.email || 'Premium Access';

    if (collapsed) {
        return (
            <div className="p-4 flex justify-center">
                <Tooltip
                    content={
                        <div className="px-1 py-2 text-center">
                            <div className="font-bold text-white">{userName}</div>
                            <div className="text-xs text-slate-400">{userDesc}</div>
                        </div>
                    }
                    placement="right"
                    classNames={{
                        content: "bg-slate-900 border border-slate-800"
                    }}
                >
                    <div className="relative group">
                        <Avatar
                            src={userAvatar}
                            isBordered
                            color="warning"
                            size="sm"
                        />
                        <div className="absolute -top-1 -right-1 w-3 h-3 bg-gradient-to-tr from-amber-400 to-orange-500 rounded-full border border-slate-950 flex items-center justify-center">
                            <Star className="w-2 h-2 text-white" fill="white" />
                        </div>
                    </div>
                </Tooltip>
            </div>
        );
    }

    return (
        <div className="p-4 mt-auto relative group">
            <div className="relative w-full rounded-2xl overflow-hidden border border-white/10 shadow-lg transition-transform duration-300 group-hover:scale-[1.02]">
                {/* Balatro Background Effect - Fixed size to prevent resize flickering */}
                <div className="absolute inset-0 z-0 opacity-75 overflow-hidden">
                    <div className="absolute inset-0" style={{ minWidth: '280px', width: '280px' }}>
                        <Balatro
                            isRotate
                            mouseInteraction={false}
                            pixelFilter={700}
                            color1="#1e293b"
                            color2="#4f46e5"
                            color3="#d946ef"
                        />
                    </div>
                </div>

                {/* Glass Overlay for Readability */}
                <div className="absolute inset-0 z-10 bg-slate-900/40 backdrop-blur-[1px]" />

                {/* Content */}
                <div className="relative z-20 p-3 flex items-center gap-3">
                    <Avatar
                        src={userAvatar}
                        isBordered
                        color="secondary"
                        size="md"
                        className="flex-shrink-0"
                    />
                    <div className="flex-1 min-w-0 overflow-hidden">
                        <div className="flex items-center gap-2">
                            <span className="font-bold text-sm truncate text-white">
                                {userName}
                            </span>
                            <Chip
                                size="sm"
                                variant="flat"
                                color="warning"
                                classNames={{
                                    base: "h-4 min-w-4 px-1 bg-amber-500/10 border border-amber-500/20",
                                    content: "text-[9px] font-bold text-amber-500 flex items-center gap-0.5"
                                }}
                            >
                                <Crown size={8} strokeWidth={3} />
                                <span>VIP</span>
                            </Chip>
                        </div>
                        <span className="text-xs text-slate-300 truncate block">
                            {userDesc}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SidebarFooter;
